import { render, staticRenderFns } from "./Programs.vue?vue&type=template&id=104ee70c&scoped=true"
import script from "./Programs.vue?vue&type=script&lang=js"
export * from "./Programs.vue?vue&type=script&lang=js"
import style0 from "./Programs.vue?vue&type=style&index=0&id=104ee70c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104ee70c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('104ee70c')) {
      api.createRecord('104ee70c', component.options)
    } else {
      api.reload('104ee70c', component.options)
    }
    module.hot.accept("./Programs.vue?vue&type=template&id=104ee70c&scoped=true", function () {
      api.rerender('104ee70c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Proposal/Programs.vue"
export default component.exports